export default __webpack_public_path__ + "static/media/strawberry-bowl.0d82e1df.svg";